<template>
	<div>
		<input ref="excel-upload-input" class="excel-upload-input" type="file" accept=".xls, .xlsx, .csv" @change="onChange">
		<div class="drop" @drop="onDrop" @dragover="onDragOver" @dragenter="onDragOver">
			<span>Arrastre el archivo</span>&emsp;
			<b-button size="lg" variant="outline-success" @click="onClick">Seleccionar</b-button>
		</div>
		<div class="info">
			<div id="excel-upload-name"></div>
			<div id="excel-upload-size"></div>
			<div id="excel-upload-type"></div>
			<div id="excel-upload-info"></div>
		</div>
	</div>
</template>
<script lang="ts">

	import XLSX from 'xlsx'


	export default 
	{
		name: "UploadExcel",
		props: {
			beforeUpload: Function,
			onSuccess: Function,
			type: {
				Type: String,
				Default: "csv"
			}
		},
		data() {
			return {
				loading: false,
				file: null,
				info: {
					nombre: "",
					tipo: "",
					tamanio: 0,
					registros: 0
				}
			}
		},
		methods: {

			onDrop() {

				e.stopPropagation()
				e.preventDefault()
				if (this.loading) 
					return

				const files = e.dataTransfer.files
				if (files.length !== 1) 
				{
					this.$message.error("Only support uploading one file!")
					return
				}

				this.file = files[0]
				const rawFile = files[0] // only use files[0]
				if (!this.isExcel(rawFile)) 
				{
					this.$message.error("Only supports upload .xlsx, .xls, .csv suffix files")
					return false
				}

				this.upload(rawFile)
				e.stopPropagation()
				e.preventDefault()
	
			},
	
			onDragOver(e) {

				e.stopPropagation()
				e.preventDefault()
				e.dataTransfer.dropEffect = "copy"
			},

			onClick() {

				this.$refs['excel-upload-input'].click()
			},

			onChange(e) {

				const files = e.target.files
				this.file = files[0]

				const rawFile = files[0]
				if (!rawFile)
					return

				this.upload(rawFile)
			},

			upload(rawFile) {

				this.$refs["excel-upload-input"].value = null	
				if (!this.beforeUpload)
				{
					this.readerData(rawFile)
					return
				}

				const before = this.beforeUpload(rawFile)
				if (before)
					this.readerData(rawFile)
			},

			readerData(rawFile) {

				return new Promise((resolve, reject) => {

					const reader = new FileReader()

					reader.onloadend = e => {

						const content = e.target.result

						// Lo hacemos asi ya que es mas rapido leer el archivo CSV que el EXCEL (por la libreria excel)
						if (this.type == "csv")
							this.readCSV(content)

						if (this.type == "xls")
							this.readXLS(content)

						resolve()
					}

					if (this.type == "csv")
						reader.readAsText(rawFile, "UTF-8")

					if (this.type == "xls")
						reader.readAsArrayBuffer(rawFile)
				})
			},

			readCSV(content) {

				var tmp = content.split("\n")
				var cabecera = tmp.shift()
				var separador = this.getSeparador(cabecera)
				const header = this.getCSVHeader(cabecera, separador)

				var data = []
				for (var t of tmp)
				{	
					var buffer = {}
					var r = t.split(separador)
					for (var i = 0; i < r.length; i++)
					{
						buffer[header[i]] = r[i].replace(/[\r]/g)
					}

					data.push(buffer)
				}

				this.generateData(header, data)
			},

			getCSVHeader(cabecera, separador) {

				const headers = []
				var campos = 0

				const data = cabecera.split(separador)

				for (var tmp of data) 
				{
					// Reemplazamos los espacios, eliminamos las comillas y otros caracteres y pasamos todo a minusculas
					var hdr = tmp.replace(/ /g, "_").replace(/[\r\"º°]/g, "").toLowerCase()

					// Agregamos el campo al header
					headers.push(hdr)
				}

				return headers
			},

			getSeparador(data) {

				// Se asume por defecto un separador de coma (,)
				var separador = ","

				// Expresion regular que obtiene todos los puntos y comas de la cabecera
				// Si no trae, el campo tmp es NULO, por lo que se asume un separador de campos ccma (,) 
				var tmp = data.match(/;/g)
				if (tmp != null)
					separador = ";"


				return separador
			},

			readXLS(content) {

				const workbook = XLSX.read(content, { type: 'array' })
				const firstSheetName = workbook.SheetNames[0]
				const worksheet = workbook.Sheets[firstSheetName]
				const header = this.getXLSHeader(worksheet)
				const results = XLSX.utils.sheet_to_json(worksheet)

				this.generateData(header, results)
			},

			getXLSHeader(sheet) {

				const headers = []
				const range = XLSX.utils.decode_range(sheet['!ref'])
				let C
				const R = range.s.r
				/* start in the first row */
				for (C = range.s.c; C <= range.e.c; ++C) { /* walk every column in the range */
					const cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })]
					/* find the cell in the first row */
					let hdr = 'UNKNOWN ' + C // <-- replace with your desired default
					if (cell && cell.t) hdr = XLSX.utils.format_cell(cell)

					hdr = hdr.replace(/ /g, "_").replace(/[\"º°]/g, "").toLowerCase()
					
					headers.push(hdr)
				}

				return headers
			},	

			generateData(header, data) {

				// Mostramos los datos del archivo en la pantalla
				document.getElementById("excel-upload-name").innerHTML = "Nombre: " + this.file.name
				document.getElementById("excel-upload-size").innerHTML = "Tamaño: " + Math.round(this.file.size / 1024) + " Kb"
				document.getElementById("excel-upload-type").innerHTML = "Tipo: " + this.file.type
				document.getElementById("excel-upload-info").innerHTML = "Registros: " + data.length 

				this.onSuccess && this.onSuccess(header, data, this.file)
			},

			isExcel(file) {

				return /\.(xlsx|xls|csv)$/.test(file.name)
			},
		}
	}
</script>
<style scoped>

	.excel-upload-input {
		display: none;
		z-index: -9999;
	}

	.drop{
		border: 2px dashed #bbb;
		width: 600px;
		height: 100px;
		line-height: 100px;
		margin: 0 auto;
		font-size: 24px;
		border-radius: 5px;
		text-align: center;
		color: #bbb;
		position: relative;
	}

	.info {
		width: 100%;
		text-align: center;
		margin-top: 10px;
	}

	.info div {
		display: inline-block;
		padding: 0px 10px 0px 10px;
		font-size: 14px;	
	}

</style>
